// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_iB","advertCardNum":"c-a_iC"};